"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var get_time_zone_offset_1 = require("./get-time-zone-offset");

function unapplyTimeZoneOffset(date, timeZone1, timeZone2) {
  var timeZoneOffset = get_time_zone_offset_1.getTimeZoneOffset(date, timeZone1, timeZone2);
  return new Date(date.valueOf() + timeZoneOffset * 60 * 1000);
}

exports.unapplyTimeZoneOffset = unapplyTimeZoneOffset;